import React from 'react';
import { IconButton, Paper, Stack, TextField, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useQuery } from '@apollo/client/react';
import { GET_GUIDES } from '../reports.graphql';
import LoadingSpinner from '../../components/LoadingSpinner';
import GuideTable from './GuideTable';

interface DocumentOverviewProps {
  onBackClick: () => void;
}

export default function DocumentOverview(props: DocumentOverviewProps) {
  const { onBackClick } = props;
  const [isGuideListVisible, setIsGuideListVisible] = React.useState(true);
  const [paginationModel, setPaginationModel] = React.useState({
    pageSize: 50,
    page: 0,
  });
  const [searchTerm, setSearchTerm] = React.useState('');
  const { loading, data } = useQuery<any, any>(GET_GUIDES, {
    variables: {
      page: paginationModel.page + 1,
      pageSize: paginationModel.pageSize,
      searchTerm: searchTerm || null,
    },
    fetchPolicy: 'network-only',
  });
  const guides = data?.allGuides?.guides?.filter(Boolean) ?? [];
  const totalCount = data?.allGuides?.totalCount;
  const [rowCountState, setRowCountState] = React.useState(totalCount ?? 0);

  React.useEffect(() => {
    setRowCountState((current) => (totalCount !== undefined ? totalCount : current));
  }, [totalCount]);

  const handleSearchTermChange = React.useCallback((value: string) => {
    setSearchTerm(value);
    setPaginationModel((current) => ({ ...current, page: 0 }));
  }, []);

  return (
    <Stack spacing={2}>
      {isGuideListVisible && (
        <Paper elevation={1} sx={{ p: 2 }}>
          <Stack spacing={2}>
            <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
              <IconButton onClick={onBackClick} title="Tilbake" size="large">
                <ArrowBackIcon />
              </IconButton>
              <div>
                <Typography variant="h6">Per Dokument</Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: 'text.secondary',
                  }}>
                  Velg anvisning for å se kunder, søk og brukerdetaljer.
                </Typography>
              </div>
            </Stack>

            <TextField
              label="Søk"
              value={searchTerm}
              onChange={(event) => handleSearchTermChange(event.target.value)}
              size="small"
              sx={{ flexGrow: 1 }}
            />

            <Typography variant="caption" sx={{ textAlign: 'right' }}>
              Antall: {rowCountState.toLocaleString('nb-NO')}
            </Typography>
          </Stack>
        </Paper>
      )}
      {loading && !data && <LoadingSpinner />}
      <GuideTable
        guides={guides}
        totalCount={rowCountState}
        loading={loading}
        searchTerm={searchTerm}
        onSearchTermChange={handleSearchTermChange}
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
        hideSearchBar
        onGuideListVisibilityChange={setIsGuideListVisible}
      />
    </Stack>
  );
}
